import Team from "../../components/Team/Index";
import NavSettings from "../../components/common/NavSettings";

const TeamPage = () => {
  return (
    <>
      <NavSettings title="Inicio" route="Inicio" active="Mi equipo"/>

      <Team />
    </>
  );
};

export default TeamPage;
